import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import * as CopyText from '@segment/matcha/recipes/CopyText'
import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'

import DemoForm from '@segment/templates/Forms/DemoForm'

import heroPng2x from './assets/Hero@2x.png'
import heroWebp from './assets/Hero.webp'
import heroWebp2x from './assets/Hero@2x.webp'

const copy = {
  overline: `Twilio Engage`,
  heading: `Build data-driven, personalized customer experiences that grow lifetime value`,
  description: `Deepen customer relationships and efficiently grow your brand by personalizing customer interactions on every channel from a unified, data-first multichannel marketing solution.`,
}

const FORM_ID = `engage-demo-request`

const Hero: FC<PropsWithChildren<unknown>> = () => {
  return (
    <Wrapper>
      <HeroBase variant="2Col">
        <HeroRecipe.Copy>
          <CopyText.Overline tag="h5" variant="h5">
            {copy.overline}
          </CopyText.Overline>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description variant="pExtraLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <HeroRecipe.Form>
            <DemoForm
              isProgressive={true}
              customFormIdentifier={FORM_ID}
              customTrackingType={FORM_ID}
              successMessageAppearance="twilioLight"
            />
          </HeroRecipe.Form>
        </HeroRecipe.Copy>

        <HeroRecipe.Contents>
          <picture>
            <source type="image/webp" srcSet={`${heroWebp}, ${heroWebp2x} 2x`} />
            <HeroRecipe.Image width="720" height="611" src={heroPng2x} alt="Twilio Engage" loading="lazy" />
          </picture>
        </HeroRecipe.Contents>
      </HeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.green[10]};
`

export default Hero
